module.exports = __webpack_public_path__ + "img/browser-bar.f8537b86.png";